module.exports = __webpack_public_path__ + "img/check-circle.36555668.svg";